import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { Client } from './Clients';

interface Movement { day: string; kind: string; src: string; dst: string; item: string; qty: number; status: string; }

export function Movements() {
  const [clients, setClients] = useState<Client[]>([]);
  const [clientId, setClientId] = useState('');
  const [kind, setKind] = useState('');
  const [since, setSince] = useState('');
  const [until, setUntil] = useState('');
  const [list, setList] = useState<Movement[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => { api<Client[]>('/v1/clients').then(setClients).catch(() => {}); }, []);

  async function load(e?: React.FormEvent) {
    e?.preventDefault();
    setError('');
    const params = new URLSearchParams();
    if (clientId) params.set('client_id', clientId);
    if (kind) params.set('kind', kind);
    if (since) params.set('since', since);
    if (until) params.set('until', until);
    try { setList(await api<Movement[]>('/v1/movements?' + params.toString())); }
    catch { setError('Erreur de chargement.'); }
  }

  return (
    <>
      <div className="pagehead"><h1>Mouvements</h1></div>
      <div className="card">
        <h2>Filtrer</h2>
        <form onSubmit={load}>
          <div className="row2">
            <div>
              <label>Client (optionnel)</label>
              <select value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">Tous</option>
                {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div>
              <label>Type (optionnel)</label>
              <select value={kind} onChange={(e) => setKind(e.target.value)}>
                <option value="">Tous</option>
                <option value="opening">Solde d'ouverture</option>
                <option value="delivery">Décompte Marjane</option>
                <option value="issue">Remise</option>
                <option value="reception">Réception</option>
                <option value="loss">Perte</option>
                <option value="inventory">Inventaire</option>
              </select>
            </div>
          </div>
          <div className="row2">
            <div><label>Depuis</label><input type="date" value={since} onChange={(e) => setSince(e.target.value)} /></div>
            <div><label>Jusqu'à</label><input type="date" value={until} onChange={(e) => setUntil(e.target.value)} /></div>
          </div>
          <div className="row" style={{ marginTop: '0.8rem' }}><button type="submit" className="primary">Filtrer</button></div>
        </form>
      </div>
      <div className="card">
        {error && <div className="err">{error}</div>}
        {!list && !error && <div className="muted">Choisissez des filtres puis cliquez sur Filtrer.</div>}
        {list && list.length === 0 && <span className="muted">Aucun mouvement pour ces filtres.</span>}
        {list && list.length > 0 && (
          <div className="tblwrap"><table><tbody>
            <tr><th>Jour</th><th>Type</th><th>De</th><th>Vers</th><th>Caisse</th><th>Qté</th><th>Statut</th></tr>
            {list.slice().reverse().map((m, idx) => (
              <tr key={idx}><td>{m.day}</td><td>{m.kind}</td><td>{m.src}</td><td>{m.dst}</td><td>{m.item}</td><td>{m.qty}</td><td>{m.status}</td></tr>
            ))}
          </tbody></table></div>
        )}
      </div>
    </>
  );
}
